import { i18n } from 'app/utils/i18n';

const StepOptions = ({ keepDismissals, onChange }) => (
  <div className="roll-forward__step">
    <h4 className="roll-forward__heading">{i18n('roll-forward.step.options')}</h4>
    <label className="roll-forward__checkbox">
      <input type="checkbox" aria-label={i18n('roll-forward.keep-dismissals')} checked={keepDismissals} onChange={(e) => onChange(e.target.checked)} />
      <span>{i18n('roll-forward.keep-dismissals')}</span>
    </label>
    <p className="roll-forward__hint text-gray-500">{i18n('roll-forward.keep-dismissals.hint')}</p>
  </div>
);

export default StepOptions;
